module.exports = __webpack_public_path__ + "img/qrcode.ca59c4cb.png";